// tslint:disable
import { Component, NgZone } from "@angular/core";
import { ITCIProductVersion, ITCIUserInfo, TCI_ENVIRONMENT_VAR_TYPE } from "@tci/common";
import { NgEnvVarsService } from "../ng-shared/ng-services/ng-env-vars.service";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { NgWindowRefService } from "../ng-shared/ng-services/ng-window-ref.service";
import { timerInZone } from "../ng-shared/ng-util/tools";
import {Observable} from "rxjs";

const PENDO_SCRIPT_URL = "https://cdn.pendo.io/agent/static/30b53883-4f50-46a5-45d9-2f87691fd3f1/pendo.js";

@Component({
    selector: "ng-scripts-pendo",
    template: ""
})
export class NgScriptsPendoComponent {
    constructor(private userService: NgUserService, private windowRef: NgWindowRefService, private ngZone: NgZone, private envVarService: NgEnvVarsService) {
        if (Array.from(document.querySelectorAll("script")).find(e => e.src === PENDO_SCRIPT_URL)) {
            console.log("Pendo Module already loaded");
            return;
        }

        const sTag = "script";
        const lastTag = document.getElementsByTagName(sTag)[0];
        const newTag = document.createElement(sTag);
        newTag.src = PENDO_SCRIPT_URL;
        newTag.onload = this.initializePendoConfig() as any;
        lastTag.parentNode.insertBefore(newTag, lastTag);
    }

    /* Initialize pendo data */
    private initializePendoConfig() {
         const userInfo = this.userService.getUserInfo();
         const envVars = this.envVarService.getEnvVar(TCI_ENVIRONMENT_VAR_TYPE.APP_VERSION)
            Observable.combineLatest(userInfo, envVars, (userInfo, envVars) => ({ userInfo, envVars}))
                .subscribe( res => {
            // .subscribe((user: ITCIUserInfo & ITCIProductVersion) => {

                const visitorId = res.userInfo.email || res.userInfo.uname;
                const accId = res.userInfo.hacct;
                const pendoInfo = {
                    apiKey: "30b53883-4f50-46a5-45d9-2f87691fd3f1",
                    visitor: {
                        id: visitorId,
                        // 'role': 'owner',
                        maskedID: res.userInfo.hid,
                        mode: "TCI",
                        // Current Product Version
                        IntegrationVersion: res.envVars[TCI_ENVIRONMENT_VAR_TYPE.APP_VERSION],
                        /* this is the type of subscription for the tenant, in your case TCI */
                        // 'IntegrationSubscriptionType': 'TRIAL',
                        /* This is needed to know whether the user is admin in TCI or not */
                        IntegrationIsTeamAdmin: res.userInfo.hasOwnProperty("admnX") ? res.userInfo.admnX : false,
                        /* This is used to know whether the user is an active member of TCI */
                        IntegrationStatus: (res.userInfo.stat === 1) ? "active" : "inactive",
                        /*This is needed to know the current region of a user */
                        region: res.userInfo.hasOwnProperty("regn") ? res.userInfo.regn : "",
                        /*This is needed to know the current subscription type of a user */
                        IntegrationSubscriptionType: res.userInfo.hasOwnProperty("st") ? res.userInfo.st : ""
                    },
                    account: {
                        id: accId
                    }
                };

                // Loop checking for pendo info to be loaded
                let tryCount = 0;
                const _window: any = this.windowRef.nativeWindow;
                const interval = timerInZone(
                    this.ngZone,
                    () => {
                        if (_window.pendo && _window.pendo.initialize) {
                            _window.pendo.initialize(pendoInfo);
                            interval.unsubscribe(); // Stop the loop
                        } else if (tryCount === 20) { // Something went wrong
                            console.error("Pendo was not able to initialize");
                            interval.unsubscribe(); // Stop the loop
                        }

                        tryCount++;
                    }, 0, 100
                ).subscribe();
            });
    }
}
